import React from "react";
import { colors } from "../constants";
import { IAnalyticsTheme } from "../types/settings";

const AnalyticsThemeContext = React.createContext<IAnalyticsTheme>({ chartColors: colors.chart });
export const Consumer = AnalyticsThemeContext.Consumer;

export default AnalyticsThemeContext;
